import { render } from "./downloadpage.vue?vue&type=template&id=18201634&scoped=true"
import script from "./downloadpage.vue?vue&type=script&lang=js"
export * from "./downloadpage.vue?vue&type=script&lang=js"

import "./downloadpage.vue?vue&type=style&index=0&id=18201634&scoped=true&lang=css"

import exportComponent from "E:\\lb\\vue30\\tuiguang_meng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18201634"]])

export default __exports__